<div class="container container-card">
    <div class="row mt-3 mb-3">
        <div class="col-12 txt-center">
            <h2 class="pt-15 pb-15">Gestione Analisi</h2>
        </div>
    </div>
    <div *ngIf="selezionaAnalisiActive" class="row mt-3 mb-3">
        <div class="col-6 md-3-offset offset-md-3">
            <!-- Ricerca analisi -->
            <div class="mb-3 position-relative">
                <label class="bold" for="typeahead-basic-analysis">Seleziona Analisi</label>
                <input 
                    #searchInputAnalysis 
                    (selectItem)="onSelectedItem($event)" 
                    id="typeahead-basic-analysis"
                    type="text" 
                    class="form-control border-light" 
                    placeholder="Ricerca analisi ..."
                    popupClass="w-100" 
                    placement="bottom-left" 
                    [(ngModel)]="model"
                    [inputFormatter]="ngbTypeaheadResultFormatter"
                    [ngbTypeahead]="search"
                    [resultTemplate]="analysisTemplate" />
                <ng-template #analysisTemplate let-r="result" let-t="term">
                    <ngb-highlight [result]="ngbTypeaheadResultFormatter(r)" [term]="t"></ngb-highlight>
                </ng-template>
            </div>
        </div>
    </div>
    <ng-container *ngIf="showDetail">
        <div class="row mt-3 mb-3">
            <div class="col">
                <label class="bold" for="piano_lavori">Piano Lavori</label>
                <input disabled id="piano_lavori" type="text" class="form-control custom-border"
                    [(ngModel)]="currentAnalysis.piano_lavori" />
            </div>
            <div class="col">
                <label class="bold" for="sr">SR</label>
                <input disabled id="sr" type="text" class="form-control custom-border"
                    [(ngModel)]="currentAnalysis.sr" />
            </div>
        </div>
        <div class="row mt-3 mb-3">
            <div class="col">
                <label class="bold" for="anno_lavori">Anno Lavori</label>
                <input disabled id="anno_lavori" type="text" class="form-control custom-border"
                    [(ngModel)]="currentAnalysis.anno_piano_lavori" />
            </div>
            <div class="col">
                <label class="bold" for="nome_sito">Nome Sito</label>
                <input disabled id="nome_sito" type="text" class="form-control custom-border"
                    [(ngModel)]="currentAnalysis.nome_sito" />
            </div>
        </div>
        <div *ngIf="selezionaGruppiActive" class="row mt-5">
            <div class="col-6 md-3-offset offset-md-3">
                <!-- Ricerca analisi -->
                <div class="mb-3 position-relative">
                    <label class="bold" for="typeahead-basic-analysis">Seleziona Gruppi</label>
                    <input #searchInputAnalysis (selectItem)="onSelectedGroup($event)" id="typeahead-basic-analysis"
                        type="text" class="form-control border-light" placeholder="Ricerca Gruppi ..."
                        ngbTooltip="Ricerca Gruppi" popupClass="w-100" placement="bottom-left" [(ngModel)]="group"
                        [inputFormatter]="ngbTypeaheadResultFormatterGroup" [ngbTypeahead]="searchGroups"
                        [resultTemplate]="groupsTemplate" />
                    <ng-template #groupsTemplate let-r="result" let-t="term">
                        <ngb-highlight [result]="ngbTypeaheadResultFormatterGroup(r)" [term]="t"></ngb-highlight>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <div class="border-dotted columns-overflow" *ngIf="groupsList.length > 0">
                    <ul class="ul-group">
                        <li *ngFor="let group of groupsList; let i = index">
                            <div class="group w-break-all">
                                {{group.name}}
                            </div>
                            <div role="button" class="group p-3 txt-bg-blu" (click)="removeGroup(i,group)">
                                <fa-icon aria-hidden="true" [icon]="faTrash"></fa-icon>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </ng-container>

</div>